export default "__VITE_ASSET__CXiouKQz__"